import React, { useState, useEffect } from 'react'
import OffToggle from '../Components/Images/OffToggle.png';
import OnToggle from '../Components/Images/OnToggle.png';

const NotificationSettings = ({ TransactionType }) => {
    const [settings, setSettings] = useState({
        account_credited: false,
        account_debited: false,
        // another: false,
        // newNotification: false,
        // fromReccur: false,
    });

    const [isDirty, setIsDirty] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState({ message: '', type: '' });

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/notifications`, {
            headers: { Authorization: `Token ${localStorage.getItem("token")}` }
        }).then(res => res.json()).then(data => setSettings(data));
    }, []);

    const toggleSetting = (key) => {
        setSettings((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
        setIsDirty(true);
    };

    const handleSave = async () => {
        setIsSubmitting(true);

        try {
            const token = localStorage.getItem("token");
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/update-notifications`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
                body: JSON.stringify(settings),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message || 'Update failed');

            setStatus({ message: 'Notification settings updated ✅', type: 'success' });
            setIsDirty(false);

        } catch (error) {
            console.error("Failed to save notification settings:", error);
            setStatus({ message: error.message, type: 'error' });
        } finally {
            setIsSubmitting(false);
            setTimeout(() => setStatus({ message: '', type: '' }), 3000);
        }
    };

    return (
        <div className={TransactionType === 'Notifications' ? 'flex flex-col gap-10 lg:w-[90%]' : 'hidden'}>
            <div className='flex items-start justify-between relative'>
                <div className='flex flex-col gap-1'>
                    <p className='text-[18px] font-medium text-[#1D1C1F]'>Notification settings</p>
                    <p className='text-[14px] font-normal text-[#525154]'>
                        Choose how and where you would like us to notify you.
                    </p>
                </div>
                <button
                    onClick={handleSave}
                    disabled={!isDirty || isSubmitting}
                    className={`text-[14px] font-medium px-4 py-[10px] rounded-lg ${!isDirty || isSubmitting
                        ? 'bg-[#E8E1F5] text-[#531CB3] cursor-not-allowed'
                        : 'bg-[#531CB3] text-white cursor-pointer'
                        }`}
                >
                    {isSubmitting ? 'Saving...' : 'Save changes'}
                </button>

                {status.message && (
                    <div className={status.type === 'error' ? 'bg-red-500 absolute top-3 left-1/2 -translate-x-1/2 text-white p-2 rounded-md flex items-center justify-between' : 'bg-green-500 absolute top-3 left-1/2 -translate-x-1/2 text-white p-2 rounded-md flex items-center justify-between'}>
                        {status.message}
                    </div>
                )}
            </div>

            <div className='flex md:flex-row flex-col gap-5'>
                <div className='md:w-[30%] flex flex-col gap-1'>
                    <div className='text-[14px] font-medium text-[#1D1C1F] flex items-center gap-1'>
                        <p>Notifications</p>
                    </div>
                    <p className='text-[14px] font-normal text-[#525154]'>
                        We will still send you important updates about your account outside of your notification settings.
                    </p>
                </div>

                <div className='flex flex-col rounded-lg border text-[#1D1C1F] text-[14px] font-normal border-[#F3F0F7] justify-between md:w-[60%]'>
                    {/* Credited */}
                    <div className='flex items-start sd:gap-[70px] gap-5 p-4 border-b border-b-[#F3F0F7]'>
                        <p className='flex-1'>When your account is credited</p>
                        <img
                            className='cursor-pointer'
                            src={settings.account_credited ? OnToggle : OffToggle}
                            alt=""
                            onClick={() => toggleSetting("account_credited")}
                        />
                    </div>

                    {/* Debited */}
                    <div className='flex items-start sd:gap-[70px] gap-5 p-4 border-b border-b-[#F3F0F7]'>
                        <p className='flex-1'>When your account is debited</p>
                        <img
                            className='cursor-pointer'
                            src={settings.account_debited ? OnToggle : OffToggle}
                            alt=""
                            onClick={() => toggleSetting("account_debited")}
                        />
                    </div>

                    {/* <div className='flex items-start sd:gap-[70px] gap-5 p-4 border-b border-b-[#F3F0F7]'>
                        <p className='flex-1'>Another notification</p>
                        <img
                            className='cursor-pointer'
                            src={settings.another ? OnToggle : OffToggle}
                            alt=""
                            onClick={() => toggleSetting("another")}
                        />
                    </div>

                    <div className='flex items-start sd:gap-[70px] gap-5 p-4 border-b border-b-[#F3F0F7]'>
                        <p className='flex-1'>New notification setting</p>
                        <img
                            className='cursor-pointer'
                            src={settings.newNotification ? OnToggle : OffToggle}
                            alt=""
                            onClick={() => toggleSetting("newNotification")}
                        />
                    </div>

                    <div className='flex items-start sd:gap-[70px] gap-5 p-4'>
                        <p className='flex-1'>Notifications from reccur</p>
                        <img
                            className='cursor-pointer'
                            src={settings.fromReccur ? OnToggle : OffToggle}
                            alt=""
                            onClick={() => toggleSetting("fromReccur")}
                        />
                    </div> */}
                </div>
            </div>
        </div >
    )
}

export default NotificationSettings
